/**
 * Modo simples (docs/refactor/51, N5): Vephus for somebody who does not program, chosen by the person —
 * in the first-run guide ("Quero usar IA no dia a dia") or in Configurações › Perfil. It hides what reads
 * as "this is not for me": the menu bar, the agent tabs, the prompt box's options and hints, the
 * architecture words; and puts the Super skills on Início as cards. Kids mode (docs/refactor/48) is the
 * same idea set by an admin for a child; this one is the person's own.
 *
 * Kept on this device, per person: the same person may want it on the family laptop and not at work, and
 * it needs nothing from the server.
 */

import { useSyncExternalStore } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from './api'

const key = (userId: string) => `devpulse:simple-mode:${userId}`
const listeners = new Set<() => void>()

export function simpleModeOn(userId: string | null | undefined): boolean {
  if (!userId) return false
  try {
    return localStorage.getItem(key(userId)) === '1'
  } catch {
    return false
  }
}

export function setSimpleMode(userId: string, on: boolean): void {
  try {
    if (on) localStorage.setItem(key(userId), '1')
    else localStorage.removeItem(key(userId))
  } catch {
    // Storage blocked: the full app, which is what it was.
  }
  for (const listener of listeners) listener()
}

/** Whether the person signed in uses Modo simples here (never for an agent's own sign-in). */
export function useSimpleMode(): boolean {
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: api.auth.me, staleTime: 5 * 60_000 })
  const userId = me && !me.isAgent ? me.userId : null
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => simpleModeOn(userId),
  )
}
